import { useState, useRef } from 'react';

export function useSpeechRecognition(roomId, participantTag, userId) {
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);

  const broadcastMessage = async (payload) => {
    try {
      await fetch('/api/broadcast-speech', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ roomId, ...payload }),
      });
    } catch (error) {
      console.error("Failed to broadcast message:", error);
    }
  };

  const toggleListening = () => {
    if (isListening) {
      recognitionRef.current?.stop();
      setIsListening(false);
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Speech Recognition API is not supported in this browser. Please use Google Chrome.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = false;
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      const text = event.results[event.results.length - 1][0].transcript.trim();
      broadcastMessage({
        speaker: participantTag || 'Guest',
        userId: userId || null,
        message: text,
        timestamp: new Date().toLocaleTimeString(),
      });
    };

    recognition.onerror = (err) => console.error("STT Error:", err);
    recognition.onend = () => setIsListening(false);
    
    recognition.start();
    recognitionRef.current = recognition;
    setIsListening(true);
  };

  return { isListening, toggleListening };
}